import * as yup from 'yup';

import { emailValidationSchema } from 'src/constants/validation';
import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { ConsumersMyVerifyFields } from '../types';

export const ConsumerMyVerifyValidationSchema = yup.object({
  [ConsumersMyVerifyFields.companyName]: yup
    .string()
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [ConsumersMyVerifyFields.firstName]: yup
    .string()
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [ConsumersMyVerifyFields.lastName]: yup.string().nullable().required(REQUIRED_VALIDATION_MESSAGE),
  [ConsumersMyVerifyFields.contactEmail]: emailValidationSchema
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [ConsumersMyVerifyFields.employers]: yup
    .array()
    .min(1, 'Select at least one employer')
    .required(),
  [ConsumersMyVerifyFields.noteToRecipient]: yup.string().nullable().optional(),
});
